import React from 'react'
import { useI18nContext } from '../_hooks/I18n'
import { colors } from '../_styles/colors'
import {
  PlaceholderItem,
  RoundPlaceholderItem,
} from './GhostPlaceholder.styles'
import type { GhostPlaceholderProps } from './GhostPlaceholder.types'

const GhostPlaceholder: React.FC<GhostPlaceholderProps> = React.memo(
  ({
    shape,
    small = false,
    startGradientColor = colors.gray94,
    endGradientColor = colors.gray20,
    ...props
  }) => {
    const i18n = useI18nContext()
    const loadingLabel = i18n.t('core.spinner.loading', {
      defaultValue: 'Loading',
    })

    if (shape === 'round') {
      return (
        <RoundPlaceholderItem
          role="img"
          aria-label={loadingLabel}
          $small={small}
          $startGradientColor={startGradientColor}
          $endGradientColor={endGradientColor}
          {...props}
        />
      )
    }
    return (
      <PlaceholderItem
        role="img"
        aria-label={loadingLabel}
        $startGradientColor={startGradientColor}
        $endGradientColor={endGradientColor}
        {...props}
      />
    )
  }
)

export default GhostPlaceholder
